/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resources_Parcel_NameInputs */

const en_resources_parcel_name = /** @type {(inputs: Resources_Parcel_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parcel`)
};

const fr_resources_parcel_name = /** @type {(inputs: Resources_Parcel_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colis`)
};

const es_resources_parcel_name = /** @type {(inputs: Resources_Parcel_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paquetes`)
};

const de_resources_parcel_name = /** @type {(inputs: Resources_Parcel_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket`)
};

const nl_resources_parcel_name = /** @type {(inputs: Resources_Parcel_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collis`)
};

/**
* | output |
* | --- |
* | "Parcel" |
*
* @param {Resources_Parcel_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "de" | "nl" }} options
* @returns {LocalizedString}
*/
const resources_parcel_name = /** @type {((inputs?: Resources_Parcel_NameInputs, options?: { locale?: "en" | "fr" | "es" | "de" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resources_Parcel_NameInputs, { locale?: "en" | "fr" | "es" | "de" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resources_parcel_name(inputs)
	if (locale === "fr") return fr_resources_parcel_name(inputs)
	if (locale === "es") return es_resources_parcel_name(inputs)
	if (locale === "de") return de_resources_parcel_name(inputs)
	return nl_resources_parcel_name(inputs)
});
export { resources_parcel_name as "resources.parcel.name" }